import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map, delay } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ChartActions, TempActions } from '@mode/charts/domain';

@Injectable({
  providedIn: 'root',
})
export class SaveIndicatorFacade {
  private isSavingNotifier: BehaviorSubject<boolean>;
  public isSaving$: Observable<boolean>;
  public isSaved$: Observable<boolean>;
  private hasErrorNotifier: BehaviorSubject<boolean>;
  public hasError$: Observable<boolean>;

  constructor(private actions$: Actions) {
    this.isSavingNotifier = new BehaviorSubject<boolean>(false);
    this.hasErrorNotifier = new BehaviorSubject<boolean>(false);
    this.isSaving$ = this.isSavingNotifier;
    this.hasError$ = this.hasErrorNotifier;
    this.isSaved$ = combineLatest([this.isSaving$, this.hasError$]).pipe(
      map(([isSaving, hasError]) => !isSaving && !hasError)
    );

    this.actions$.pipe(ofType(ChartActions.updateChart, ChartActions.updateChartNoEncoding)).subscribe(() => {
      this.isSavingNotifier.next(true);
      this.hasErrorNotifier.next(false);
    });

    this.actions$.pipe(ofType(ChartActions.updateChartFailure)).subscribe(() => {
      this.isSavingNotifier.next(false);
      this.hasErrorNotifier.next(true);
    });

    this.actions$.pipe(ofType(TempActions.loadExploration.type)).subscribe(() => {
      this.isSavingNotifier.next(false);
      this.hasErrorNotifier.next(false);
    });

    this.actions$.pipe(ofType(ChartActions.updateChartSuccess), delay(1000)).subscribe(() => {
      this.isSavingNotifier.next(false);
    });
  }
}
